import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import _ from 'lodash';
import { SelectField, TextField } from 'src/jbc-front/components/Form';
import { selectOptionMonths } from 'src/utils/Utils';
import { FormSubmitBtn } from 'src/buttons';
import { DESK_SSO_RATE_FORM } from 'src/constants/FormNames';
import { isPercentage, isThaiMoney } from 'src/utils/CustomValidators';
import { NATIONALITY_TYPES, LIST_RATE_TYPES } from 'src/constants/Options';

const SsoRateForm = props => {
  const { handleSubmit, submit, pristine, submitting, allYear, formValues, searchDeskSso } = props;
  const { year, month, rateType, employeeType } = formValues;

  useEffect(() => searchDeskSso(year, month, rateType, employeeType), [formValues.year, formValues.month, formValues.rateType, formValues.employeeType]);

  return (
    <form onSubmit={handleSubmit}>
      <SelectField label="year" name="year" options={allYear} required />
      <SelectField label="month" name="month" options={selectOptionMonths} required />
      <SelectField label="Types" name="rateType" options={LIST_RATE_TYPES} required />
      <SelectField label="Employee types" name="employeeType" options={NATIONALITY_TYPES} required />
      {/*<TextField label="min amount" type="text" name="minAmount" validate={isThaiMoney} required />*/}
      {/*<TextField label="max amount" type="text" name="maxAmount" validate={isThaiMoney} required />*/}
      <TextField label="contribution rate employee" type="text" name="contributionRateEmployee" validate={isPercentage} required />
      <TextField label="contribution rate employer" type="text" name="contributionRateEmployer" validate={isPercentage} required />
      <div className="u-ta-c u-mt30">
        <FormSubmitBtn 
          text="Update"
          {...{ submitting, submit }}
          disabled={ submitting || pristine }
        />
      </div>
    </form>
  );
};

const mapStateToProps = state => ({
  formValues: getFormValues(DESK_SSO_RATE_FORM)(state)
})

export default connect(mapStateToProps)(SsoRateForm);